<information-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><h1 class="heading-01 heading_news">お知らせ</h1></li>
    </ul>
    
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area">
      
      <div class="container_sort margin-spacing-2_bottom">
        
        <div class="box_sort">
          <div class="sort-menu margin-spacing-2_right">
            <select name="sort" class="sort-list" onchange={(e)=>limitService(e)}>
              <option value="">全て</option>
              <option value="system">運営</option>
              <option value="edilent">案件</option>
            </select>
          </div><!--/.sort-menu-->
          <div class="sort-menu">
            <select name="sort" class="sort-list" onchange={(e)=>limitYear(e)}>
              <option value="">全て</option>
              <option value="{year}" each={year in Object.keys([0,1,2,3]).map(d=>new Date().getFullYear() -d)}>{year}年</option>
            </select>
          </div><!--/.sort-menu-->
        </div><!--/.box_sort-->
        <p class="search_number">全{state.datainfo.total}件中　{state.datainfo.start}〜{state.datainfo.end}件</p>
      </div><!--/.container_sort-->	
        
      <div class="contents_block" if={state.informations.length > 0}>
        <ul class="table_list">
          <li class="table_list-item" each={info in state.informations}>
            <span class="date">{info.created_at}</span>
            <span class="label {informationLabel(info.service)}"></span>
            <a onclick={(e)=>openMessage(e, info)}>{info.title}</a>
          </li>
        </ul>
      </div><!--/.contents_block-->
      <div class="empty" if={state.informations.length == 0}>
        <p class="empty-message">お知らせはありません。</p>
      </div>

      <edilent-pagination-tag pager="{state.pager}" onpager="{(e,page)=>select(e,page)}" if={state.pager.last > 1}></edilent-pagination-tag>
    </section><!--/.contents_area-->
    
  </div><!--/.contents-->

<script>
  import di from "dependency-injection";
  import InformationLabel from "@model/information-label.js";
  export default {
    informationLabel: InformationLabel.get,
    state: {
      limitYear: '',
      limitService: '',
      info: {},
      informations: [],
      isLoading: true,
      page: 1,
      pager: {page: 1, total: 0, last: 0,  prev: 0, next: 0},
      datainfo: {total: 0, start: 0, end:0}
    },
    limitYear(e) {
      this.state.limitYear = e.target.value;
      this.state.page = 1;
      this.api.request('information', 'fetch', {service: this.state.limitService, year:this.state.limitYear})
      .then(data=>this.reload(data));

    },
    limitService(e){
      let service = e.target.value;
      this.state.limitService = service;
      this.state.page = 1;
      this.api.request('information', 'fetch', {service: service, year: this.state.limitYear})
      .then(data=>this.reload(data));
    },
    openMessage(e, info){
      di.router.push(`/menu/information/${info.id}`);
    },
    select(e, page) {
      e.preventDefault();
      this.state.page = page;
      this.api.request('information', 'fetch', {page: page, service: this.state.limitService, year: this.state.limitYear})
      .then(data=>this.reload(data));
    },
    reload(data){
      const start = 1 + ((data.page -1) * 10);
      this.update({
        informations: data.items,
        isLoading   : false,
        pager       : data,
        page        : data.page,
        datainfo    :{
          total: data.total,
          start: start,
          end: start + data.items.length - 1
      }
      });
    },
    onBeforeMount(props, state){
      this.api = di.createApi('menu');
      this.api.request('information', 'fetch', {limit: props.limit, service: this.state.limitService, year: this.state.limitYear})
      .then(data=>this.reload(data));
    }
  }
</script>
</information-tag>
